import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { colors, radii } from '../../styles/tokens';

export type DataSourceType = 'live' | 'mock' | 'static' | 'api-key' | 'wip';

const typeStyles: Record<
  DataSourceType,
  { bgcolor: string; color: string; border: string }
> = {
  live: {
    bgcolor: alpha(colors.success, 0.1),
    color: '#1F5C43',
    border: alpha(colors.success, 0.3),
  },
  mock: {
    bgcolor: alpha(colors.warning, 0.1),
    color: '#8A5E0B',
    border: alpha(colors.warning, 0.3),
  },
  static: {
    bgcolor: alpha(colors.textSecondary, 0.1),
    color: '#6E5F4B',
    border: alpha(colors.textSecondary, 0.25),
  },
  'api-key': {
    bgcolor: alpha(colors.info, 0.1),
    color: '#14544A',
    border: alpha(colors.info, 0.3),
  },
  wip: {
    bgcolor: alpha(colors.textSecondary, 0.08),
    color: '#8A7A63',
    border: alpha(colors.textSecondary, 0.25),
  },
};

export interface DataSourceBadgeProps {
  label: string;
  type?: DataSourceType;
}

export const DataSourceBadge: React.FC<DataSourceBadgeProps> = ({
  label,
  type = 'live',
}) => {
  const style = typeStyles[type];

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      sx={{
        height: 24,
        fontSize: '0.75rem',
        fontWeight: 500,
        borderRadius: `${radii.badge}px`,
        bgcolor: style.bgcolor,
        color: style.color,
        borderColor: style.border,
        '& .MuiChip-label': {
          px: 1.25,
        },
      }}
    />
  );
};
